import React from 'react';
import i18n from '@/utils/i18n';

export function formatContainerCount(
  containers: number,
  boxes: number,
): React.ReactNode {
  if (containers === 0 && boxes === 0) return '0';
  if (containers === 0 && boxes > 0) return boxes; // used for container station only

  const boxLabel = boxes === 1 ? i18n.t('Event:box') : i18n.t('Event:boxes');
  const containerLabel =
    containers === 1 ? i18n.t('Event:container') : i18n.t('Event:containers');
  return (
    <>
      {boxes} {boxLabel}
      <span className="tw:pl-1 tw:text-neutral-500 tw:dark:text-neutral-400">
        ({containers.toLocaleString()} {containerLabel})
      </span>
    </>
  );
}
